import styled from 'styled-components';

import { Form as SemanticForm } from 'semantic-ui-react';

import {
  Button as ButtonLayoutComponent, Loader as LoaderLayoutComponent, Segment as SegmentLayoutComponent, Text as TextLayoutComponent,
} from '@playbookux/playbook-web-core';

const Container = styled.div`
  padding-top: 100px;
  ${({ center }) => center && `
    display: flex;
    justify-content: center;
  `}
`;

const Segment = styled(SegmentLayoutComponent).withConfig({
  shouldForwardProp: (prop) => prop !== 'isPadding',
})`
  &.ui.segment {
    width: 650px;
    margin-left: auto;
    margin-right: auto;
    padding: 30px ${({ isPadding }) => (isPadding ? '100px' : '')};

    @media screen and (max-width: 420px ) {
      margin: 100px 30px 0px 30px;
      padding: 10px;
      width: auto;
    };
  }

`;

const Text = styled(TextLayoutComponent)`
  @media screen and (max-width: 420px ) {
    margin: 5px 0 5px 20px;
  };
`;

const TextError = styled(TextLayoutComponent.Error)`
  padding: 30px;
  font-size: 4vw;
`;

const Instruction = styled(TextLayoutComponent)`
  margin-bottom: 5px;
`;

const Header = styled(TextLayoutComponent)`
  margin-bottom: 20px;
`;

const FieldContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 30px 0 10px 0;

  @media screen and (max-width: 420px ) {
    flex-direction: column;
    align-items: flex-start;
    align-content: flex-start;
    };
`;

const InputContainer = styled.div`
  flex: 4;
  padding: 0 20px 0 20px;
  width: 185px;
`;

const SmallContainer = styled.div`
  width: 300px;
  margin-left: auto;
  margin-right: auto;
    @media screen and (max-width: 991px) {
    width: 80%;
  };
`;

const InlineFieldContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 15px;
  align-items: center;
`;

const InlineLabel = styled(TextLayoutComponent)`
  display: inline-flex;
  margin-right: 10px;
`;

const InlineInputContainer = styled.div`
  width: calc(100% - 80px);
`;

const Logo = styled.img`
  margin-bottom: 50px;
  max-width: 125px;
  margin-left: auto;
  margin-right: auto;
  display: block;
`;

const Button = styled(ButtonLayoutComponent)`
  &.ui.button {
    margin: 40px auto 0;
    display: block;
  }
`;

const Loader = styled(LoaderLayoutComponent).attrs(() => ({
  inline: false,
}))``;

const Message = styled(TextLayoutComponent)`
  margin-bottom: 40px;
  font-size: 18px;
  text-align: center;
`;

const NDA = styled(TextLayoutComponent)`
  margin-top: 40px;
  margin-bottom: 40px;
  font-size: 14px;
  text-align: center;
`;

const ContainerInputText = styled.div`
  display: flex;
  align-items: center;
  width: 335px;
  ${({ hasMarginTop }) => hasMarginTop && 'margin-top: 15px;'};
`;

const ContentSegment = styled.div`
  display: flex;
  justify-content: center;
`;

const FieldContainerInput = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 30px 0 10px 0;
`;

const SemanticFormCustom = styled(SemanticForm)`
  display: flex;
`;

export {
  Container,
  Segment,
  Text,
  TextError,
  Header,
  FieldContainer,
  InputContainer,
  InlineFieldContainer,
  InlineLabel,
  InlineInputContainer,
  Logo,
  SmallContainer,
  Button,
  Loader,
  Message,
  NDA,
  Instruction,
  ContainerInputText,
  ContentSegment,
  FieldContainerInput,
  SemanticFormCustom,
};
